(()=>{const modal=document.querySelector('[data-v171-modal]');if(!modal)return;
const title=modal.querySelector('[data-v171-title]'),image=modal.querySelector('[data-v171-image]'),price=modal.querySelector('[data-v171-price]'),meta=modal.querySelector('[data-v171-ref]'),variantsBox=modal.querySelector('[data-v171-variants]'),wrap=modal.querySelector('[data-v171-variant-wrap]'),qtyNode=modal.querySelector('[data-v171-qty]'),add=modal.querySelector('[data-v171-add]');
const fulfillment=document.createElement('span');
fulfillment.className='mh-availability-badge';
fulfillment.setAttribute('aria-live','polite');
price.insertAdjacentElement('afterend',fulfillment);
let active=null,qty=1,last=null;

const tidy=s=>String(s||'').replace(/[–—]/g,'—').replace(/\s+/g,' ').trim();

function variantInfo(v){
  let base=tidy(v.title).replace(/\s*[—-]\s*Ref\.?\s*[:.-]?\s*[A-Za-z0-9-]+\s*$/i,'').trim();
  const compound=(base.match(/\b\d+\s*un\.?\s*(?:c\/|\||x)\s*\d+(?:[.,]\d+)?\s*(?:g|ml)\s*cada\b/i)||[])[0]||'';
  const simple=(base.match(/\b\d+(?:[.,]\d+)?\s*(?:ml|g|kg)\b/i)||[])[0]||'';
  const units=(base.match(/\b\d+\s*un\.?\b/i)||[])[0]||'';
  const size=compound||simple||units;

  let type='';
  if(/\bc[aá]psulas?\b/i.test(base)) type='Cápsulas';
  else if(/\bspray\b/i.test(base)) type='Spray';
  else if(/\bpomada\b/i.test(base)) type='Pomada';
  else if(/\bcreme\b/i.test(base)) type='Creme';
  else if(/\b[oó]leo\b/i.test(base)) type='Óleo';
  else if(/\bgel\b/i.test(base)) type='Gel';

  if(type==='Gel'){
    if(/\bumectante\b/i.test(base)) type='Gel umectante';
    else if(/\bbeij[aá]vel\b/i.test(base)) type='Gel beijável';
    else if(/\bt[eé]rmic[oa]\b/i.test(base)) type='Gel térmico';
  }

  let chip=base;
  if(size) chip=chip.replace(size,' ');
  chip=chip
    .replace(/\b(c[aá]psulas?|spray|pomada|creme|[oó]leo|gel|umectante|beij[aá]vel|t[eé]rmic[oa]|corporal|l[ií]quido)\b/gi,' ')
    .replace(/\s*[—|•-]+\s*/g,' ')
    .replace(/\s+/g,' ')
    .trim();

  if(!chip || /^default title$/i.test(chip)) chip=type||'Padrão';
  if(chip.length>28) chip=chip.slice(0,27).trim()+'…';

  const details=[];
  if(type) details.push(type);
  if(size) details.push(size.replace(/\s+/g,' '));
  if(v.sku) details.push('Ref. '+v.sku);
  return {chip,legend:details.join(' • ')};
}

function selectUI(btn,v,changeImage=true){
  variantsBox.querySelectorAll('.mh-v171-variant').forEach(x=>x.classList.remove('is-active'));
  btn.classList.add('is-active');
  active=v;
  price.textContent=v.price||'';
  const info=variantInfo(v);
  meta.textContent=info.legend;
  const ready=v.fulfillment==='ready';
  fulfillment.textContent=ready?'Pronta entrega':'Sob encomenda';
  fulfillment.className='mh-availability-badge '+(ready?'is-ready':'is-order');
  if(changeImage&&v.image) image.src=v.image;
  add.disabled=v.available==='false';
  add.textContent=add.disabled?'×':'🛒';
  add.setAttribute('aria-label',add.disabled?'Produto indisponível':'Adicionar ao carrinho');
}

function open(card,trigger){
  const data=card.querySelector('[data-v171-data]');
  const vars=[...card.querySelectorAll('[data-v171-variant]')].map(v=>({id:v.dataset.id,title:v.dataset.title,sku:v.dataset.sku,price:v.dataset.price,image:v.dataset.image,available:v.dataset.available,fulfillment:v.dataset.fulfillment}));
  if(!data||!vars.length)return;
  last=trigger;qty=1;qtyNode.textContent='1';
  title.textContent=card.dataset.title||'Produto';
  image.src=data.dataset.productImage||vars[0].image||'';
  image.alt=title.textContent;
  variantsBox.innerHTML='';
  const infos=vars.map(v=>variantInfo(v));
  const counts={};
  infos.forEach(info=>{const k=info.chip.toLowerCase();counts[k]=(counts[k]||0)+1});
  let firstBtn=null;
  const h=card.dataset.handle||'';
  modal.dataset.handle=h;
  const noVariantPhotos=h==='fantasias-comestiveis';
  const usedLabels={};
  vars.forEach((v,i)=>{
    const info=infos[i];
    let label=info.chip;
    if((counts[info.chip.toLowerCase()]||0)>1){
      const size=(info.legend.match(/(?:^| • )(\d+(?:[.,]\d+)?\s*(?:ml|g|kg)|\d+\s*un\.?(?:\s*[|x/]\s*\d+(?:[.,]\d+)?\s*(?:g|ml)\s*cada)?)(?: • |$)/i)||[])[1]||'';
      if(size) label=(label+' '+size).trim();
    }
    const lk=label.toLowerCase();
    if(usedLabels[lk] && v.sku) label=(label+' · Ref. '+v.sku).trim();
    usedLabels[label.toLowerCase()]=true;
    const b=document.createElement('button');
    b.type='button';
    b.className='mh-v171-variant';
    b.textContent=label;
    const status=document.createElement('small');
    status.className='mh-variant-fulfillment';
    status.textContent=v.fulfillment==='ready'?'Pronta entrega':'Sob encomenda';
    b.appendChild(status);
    b.title=v.title||label;
    b.dataset.variantId=v.id;
    b.dataset.variantSku=v.sku||'';
    b.addEventListener('click',()=>selectUI(b,v,!noVariantPhotos));
    variantsBox.appendChild(b);
    if(i===0)firstBtn=b;
  });
  if(firstBtn){const photoFirst=['capas-sensoriais','poesie-desodorante-intimo','poesie-esfoliante','corpo-a-corpo'].includes(h);selectUI(firstBtn,vars[0],photoFirst&&!noVariantPhotos);}
  wrap.hidden=vars.length<=1;
  modal.hidden=false;
  document.documentElement.classList.add('mh-v171-lock');
  setTimeout(()=>modal.querySelector('[data-v171-close]')?.focus(),20);
}

function close(){modal.hidden=true;document.documentElement.classList.remove('mh-v171-lock');active=null;last?.focus()}

document.addEventListener('click',async e=>{
  const carouselOpener=e.target.closest('[data-v171-carousel-open]');
  if(carouselOpener){
    e.preventDefault();
    e.stopImmediatePropagation();
    const mini=carouselOpener.closest('.mh-mini-card');
    const proxy=mini?.querySelector('.mh-v171-carousel-proxy [data-v171-card]');
    if(proxy) open(proxy,carouselOpener);
    return;
  }
  const opener=e.target.closest('[data-v171-open]');
  if(opener){e.preventDefault();e.stopImmediatePropagation();const card=opener.closest('[data-v171-card]');if(card)open(card,opener);return}
  if(e.target.closest('[data-v171-close]')){e.preventDefault();close();return}
  if(e.target.closest('[data-v171-minus]')){qty=Math.max(1,qty-1);qtyNode.textContent=String(qty);return}
  if(e.target.closest('[data-v171-plus]')){qty++;qtyNode.textContent=String(qty);return}
  if(e.target.closest('[data-v171-add]')&&active){
    e.preventDefault();add.disabled=true;add.textContent='⏳';add.setAttribute('aria-label','Adicionando ao carrinho');
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(active.id),quantity:qty})});
      if(!r.ok){
        const detail=await r.json().catch(()=>({}));
        throw new Error(detail.description||detail.message||'Não foi possível adicionar este produto ao carrinho.');
      }
      add.textContent='✓';add.setAttribute('aria-label','Adicionado ao carrinho');
      setTimeout(()=>{close();const t=document.querySelector('[data-cart-toggle]');if(t)t.click()},450);
    }catch(err){add.disabled=false;add.textContent='🛒';add.setAttribute('aria-label','Tentar adicionar ao carrinho');alert(err.message||'Não foi possível adicionar este produto ao carrinho.')}
  }
},true);
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close()});
})();
